import type { ShippingAddress } from '@flashcard/shared';

interface AddressFormProps {
  value: ShippingAddress;
  onChange: (address: ShippingAddress) => void;
  errors?: Partial<Record<keyof ShippingAddress, string>>;
}

export function AddressForm({ value, onChange, errors = {} }: AddressFormProps) {
  const handleChange = (field: keyof ShippingAddress, e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...value, [field]: e.target.value });
  };

  return (
    <form className="grid grid-2" onSubmit={(e) => e.preventDefault()}>
      <div className="form-group">
        <label>Vorname *</label>
        <input value={value.firstName} onChange={(e) => handleChange('firstName', e)} required />
        {errors.firstName && <p className="error">{errors.firstName}</p>}
      </div>
      <div className="form-group">
        <label>Nachname *</label>
        <input value={value.lastName} onChange={(e) => handleChange('lastName', e)} required />
        {errors.lastName && <p className="error">{errors.lastName}</p>}
      </div>
      <div className="form-group" style={{ gridColumn: '1 / -1' }}>
        <label>Firma</label>
        <input value={value.company || ''} onChange={(e) => handleChange('company', e)} />
      </div>
      <div className="form-group" style={{ gridColumn: '1 / -1' }}>
        <label>Straße &amp; Nr. *</label>
        <input value={value.addressLine1} onChange={(e) => handleChange('addressLine1', e)} required />
        {errors.addressLine1 && <p className="error">{errors.addressLine1}</p>}
      </div>
      <div className="form-group" style={{ gridColumn: '1 / -1' }}>
        <label>Adresszusatz</label>
        <input value={value.addressLine2 || ''} onChange={(e) => handleChange('addressLine2', e)} />
      </div>
      <div className="form-group">
        <label>PLZ *</label>
        <input value={value.postalCode} onChange={(e) => handleChange('postalCode', e)} required />
        {errors.postalCode && <p className="error">{errors.postalCode}</p>}
      </div>
      <div className="form-group">
        <label>Stadt *</label>
        <input value={value.city} onChange={(e) => handleChange('city', e)} required />
        {errors.city && <p className="error">{errors.city}</p>}
      </div>
      <div className="form-group">
        <label>Bundesland</label>
        <input value={value.state || ''} onChange={(e) => handleChange('state', e)} />
      </div>
      <div className="form-group">
        <label>Land * (ISO-Code, z.B. DE)</label>
        <input value={value.country} onChange={(e) => handleChange('country', e)} required maxLength={2} />
        {errors.country && <p className="error">{errors.country}</p>}
      </div>
      <div className="form-group">
        <label>Telefon</label>
        <input value={value.phone || ''} onChange={(e) => handleChange('phone', e)} type="tel" />
      </div>
      <div className="form-group">
        <label>E-Mail für Versand</label>
        <input value={value.email || ''} onChange={(e) => handleChange('email', e)} type="email" />
      </div>
    </form>
  );
}
